// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"97ccab2c","613":"51a8f133","654":"6f2a5922","997":"f23c77d2"}[chunkId] + ".chunk.js";
};